import React from "react";

const SlidesRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 4,
  width: 8,
  height: 12,
  rx: 2,
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 4H1.5C2.60457 4 3.5 4.89543 3.5 6V14C3.5 15.1046 2.60457 16 1.5 16H1",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 16L18.5 16C17.3954 16 16.5 15.1046 16.5 14L16.5 6C16.5 4.89543 17.3954 4 18.5 4L19 4",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SlidesRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;